var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "dashboard" } },
    [
      _c("dashboard-filters-view", {
        attrs: {
          value: _vm.filters,
          onChange: _vm.onChangeFilters,
          clear: _vm.clearFilters
        }
      }),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-4 col-md-6" },
          [
            _c(
              "b-card",
              {
                staticClass: "card-congratulation-medal",
                staticStyle: { "min-height": "182px" }
              },
              [
                _c("h5", [
                  _vm._v(" En este transcurso "),
                  _c("br"),
                  _vm._v(" de tiempo han realizado ")
                ]),
                _c("h3", { staticClass: "mb-75 mt-5 pt-50" }, [
                  _vm._v(
                    " " + _vm._s(_vm.dashboardResume.total) + " procesos "
                  ),
                  _c("br"),
                  _vm._v(" de aprobaciones ")
                ]),
                _c("b-img", {
                  staticClass: "congratulation-medal",
                  attrs: {
                    src: require("@/assets/images/badge.svg"),
                    alt: "Medal Pic"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        !_vm.loading
          ? _c(
              "div",
              { staticClass: "col-lg-8 col-md-6" },
              [
                _c("dashboard-indicators", {
                  attrs: { indicators: _vm.dashboardApprovalsIndicators }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      !_vm.loading
        ? _c("dashboard-resume", { attrs: { resume: _vm.dashboardResume } })
        : _vm._e(),
      _c("div", { staticClass: "row", attrs: { id: "details" } }, [
        _c("div", { staticClass: "col-12 mb-3" }, [
          _c("h4", { staticClass: "text-primary" }, [
            _vm._v(
              " Flujos en curso pendientes de aprobación (" +
                _vm._s(_vm.dashboardResume.enCurso) +
                ") "
            )
          ]),
          _c("small", [
            _vm._v(
              " Selecciona una aprobación del listado para ver su detalle "
            )
          ])
        ]),
        !_vm.loading
          ? _c(
              "div",
              { staticClass: "col-8" },
              [
                _c("table-dashboard-approvals", {
                  attrs: { approvals: _vm.dashboardApprovalsList },
                  on: { select: _vm.selectFlow }
                })
              ],
              1
            )
          : _vm._e(),
        !_vm.loading
          ? _c(
              "div",
              { staticClass: "col-4" },
              [
                _c("dashboard-detail-flow", {
                  attrs: {
                    flow: _vm.detailsFlow,
                    approvalFlow: _vm.dashboardApprovalFlow
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "position-fixed download text-left m-auto" },
            [
              _c(
                "div",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "badge-glow",
                      attrs: { variant: "warning" },
                      on: { click: _vm.downloadData }
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "DownloadIcon" }
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v("Descargar")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }